import FreemiumEventDetails from './FreemiumEventDetails';

export default FreemiumEventDetails;
